const and = (...predicates) => {
  return traffic => {
    return predicates.every(predicate => {
      return predicate(traffic)
    })
  }
}

export default and



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/predicates/and.js